<template>
  <div style="background:#f4f4f4;padding-bottom:20px;">
    <div class="auto_">
      <div class="success_title success_title_  clearfix_">
        <div class="fl success_title_logo"><img :src="logo" alt=""></div>
        <div class="fl success_title_txt">收银台</div>
      </div>
      <div class="stay_pay_rqcode clearfix_">
        <div class="fl stay_pay_rqcode_img"><img :src="timg" alt=""></div>
        <div class="fl stay_pay_rqcode_txt">
          <p>订单提交成功，请尽快完成支付，订单号：{{orderData.scode}}</p>
          <p>请在<span>20分钟</span>内完成支付，否则订单自动取消</p>
        </div>
      </div>
      <div class="stay_pay_content">
        <div class="stay_pay_price">待付款金额：&nbsp;&nbsp;<em>¥&nbsp;</em><span>{{orderData.price}}</span></div>
        <div class="stay_pay_mode clearfix_">
          <div v-show="zfbIsShow" @click="pay('zfb')" class="fl clearfix_ stay_pay_mode_item">
            <div class="fl stay_pay_mode_item_img"><img :src="zfb" alt=""></div>
            <div class="fl stay_pay_mode_item_txt">支付宝支付</div>
          </div>
          <div v-show="wxIsShow" @click="pay('wx')" class="fl clearfix_ stay_pay_mode_item">
            <div class="fl stay_pay_mode_item_img"><img :src="wx" alt=""></div>
            <div class="fl stay_pay_mode_item_txt">微信支付</div>
          </div>
          <!-- <div @click="pay" class="fl clearfix_ stay_pay_mode_item">
            <div class="fl stay_pay_mode_item_img"><img :src="yl" alt=""></div>
            <div class="fl stay_pay_mode_item_txt">银联支付</div>
          </div> -->
          <!-- <div @click="pay('hdfk')" class="fl clearfix_ stay_pay_mode_item">
            <div class="fl stay_pay_mode_item_img"><img :src="hdfk" alt=""></div>
            <div class="fl stay_pay_mode_item_txt">货到付款</div>
          </div> -->
        </div>
      </div>
    </div>
    <div v-show="maskShow" :style="height_" class="mask">
      <div @click="off" class="off"></div>
      <img class="i_m_g" :src="wx_url" alt="">
      <p style="color:#fff;text-align:center;margin-top:30%;">微信扫码支付</p>
    </div>
  </div>
</template>
<script>
import memberHeader from '@/components/member/member_header'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return{
      logo:require('../../assets/img/logo__.png'),
      timg:require('../../assets/img/niu.png'),
      zfb:require('../../assets/img/zfb.png'),
      wx:require('../../assets/img/wx.png'),
      yl:require('../../assets/img/yl.png'),
      hdfk:require('../../assets/img/hdfk.png'),
      outTradeNo:'',
      orderData:{},
      zfbIsShow:0,
      wxIsShow:0,
      time:12,
      maskShow:false,
      height_:{},
      wx_url:''
    }
  },
  mounted:function(){
    this.outTradeNo=this.$route.query.id
    this.orderId=this.$route.query.orderId
    this.payment()
    this.getPayType()
  },
  methods:{
    off:function(){
      var t_=this
      t_.maskShow=false
      t_.time=0
    },
    getPayType:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
      })
      axios.post(`${ip}formWorkInterface/getPayType`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.zfbIsShow=res.data.zfbPayStatus
          t_.wxIsShow=res.data.wxPayStatus
        }
      })
    },
    pay:function(mode){
      var t_=this
      if(t_.orderData.status!=1)return t_.$message({
        message:'请不要重复支付订单。',
        center:true,
        type:'warning'
      })
      var data0bj=({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:this.orderId
      })
      if(mode=='zfb'){
        data0bj.payType=6
        if(window.location.host.indexOf('localhost')!=-1){
          data0bj.returnUrl='http://'+window.location.host+'/paySuccess'
        }else{
          data0bj.returnUrl='https://'+window.location.host+'/paySuccess'
        }
      }else if(mode=='wx'){
        data0bj.payType=3
      }else if(mode=='hdfk'){
        data0bj.payType=1
      }
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/unifiedOrder`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.payType==6){
            document.write(res.data.data)
          }else if(res.data.payType==3){
            t_.height_={
              height:window.screen.height+'px'
            }
            t_.maskShow=true
            t_.height_=window.screen.height
            t_.wx_url=res.data.data
            t_.outTradeNo=res.data.outTradeNo
            t_.fn()
          }else if(res.data.payType==1){
            t_.$router.push({name:'paySuccess',query:{outTradeNo:res.data.outTradeNo}})
          }
        }
      })
    },
    fn:function(){
      var t_=this
      setTimeout(function(){
        t_.time=--t_.time
        t_.payment()
        if(t_.time>0){
          t_.fn()
        }
        if(t_.time==0){
          t_.$router.push({name:'paySuccess',query:{outTradeNo:t_.outTradeNo}})
        }
      },5000,t_)
    },
    payment:function(){
      var t_=this
      var data0bj=({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:this.orderId
      })
      data0bj.outTradeNo=this.outTradeNo
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/payment`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          this.orderData=res.data.data
        }else if(res.data.code==-550){
          this.payment()
        }
      })
    }
  }
}
</script>

<style>
  .auto_{
    width: 1200px;
    margin: 0 auto;
  }
  .success_title{
    width: 1200px;
    height: 110px;
  }
  .success_title_{
    height: 85px;
  }
  .success_title_logo{
    width: 68px;
    height: 68px;
  }
  .success_title_logo img{
    height: 68px;
    width: 68px;
  }
  .success_title_txt{
    color:#f12002;
    font-size: 28px;
    line-height: 68px;
    margin-left:15px;
  }
  .stay_pay_rqcode{
    margin-bottom:35px;
  }
  .stay_pay_rqcode_img{
    width: 76px;
    height: 76px;
    padding: 6px;
    background: #fff;
    border: 1px solid #fc9e9e;
    margin-right: 20px;
  }
  .stay_pay_rqcode_img img{
    width: 76px;
    height: 76px;
  }
  .stay_pay_rqcode_txt{
    padding-top: 16px;
  }
  .stay_pay_rqcode_txt p{
    margin-bottom: 20px;
    font-size:16px;
  }
  .stay_pay_rqcode_txt span{
    color:#f22103;
  }
  .stay_pay_content{
    background: #fff;
    padding: 70px 52px 0 52px;
  }
  .stay_pay_price{
    font-size:22px;
    color:#333;
    text-align: center;
    padding-bottom: 30px;
    border-bottom: 1px solid #f4f4f4;
  }
  .stay_pay_price em{
    color:#f41e04;
  }
  .stay_pay_price span{
    font-size:34px;
    color:#f41e04;
  }
  .stay_pay_mode{
    padding-left: 200px;
    padding-top: 66px;
    padding-bottom: 45px;
  }
  .stay_pay_mode .stay_pay_mode_item{
    width: 405px;
    margin-bottom: 30px;
    cursor: pointer;
  }
  .stay_pay_mode_item_img{
    width: 43px;
    height: 43px;
    margin-right: 20px;
  }
  .stay_pay_mode_item_img img{
    width: 43px;
    height: 43px;
  }
  .stay_pay_mode_item_txt{
    font-size:20px;
    color:#333;
    line-height: 43px;
  }
  .mask{
    width: 100%;
    height: 100%;
    background:rgba(0, 0, 0, .6);
    position: fixed;
    top: 0;
    left:0;
    z-index: 9999999;
  }
  .i_m_g{
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -85px;
    margin-left: -85px;
  }
  .off{
    width: 32px;
    height: 32px;
    background: url(../../assets/img/off.png);
    position: absolute;
    top: 35%;
    right: 42%;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/stayPay.vue